import { render, staticRenderFns } from "./add-royalty-plan-second.vue?vue&type=template&id=1f832eee&scoped=true&"
import script from "./add-royalty-plan-second.vue?vue&type=script&lang=js&"
export * from "./add-royalty-plan-second.vue?vue&type=script&lang=js&"
import style0 from "./add-royalty-plan-second.vue?vue&type=style&index=0&id=1f832eee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f832eee",
  null
  
)

export default component.exports